<template>
  <v-dialog
    v-model="dialogVisible"
    transition="route"
    max-width="400"
    persistent
  >
    <v-card
      class="rounded-xl pa-4"
      style="position: relative; padding-top: 32px;"
    >
      <!-- X Button for alert only -->
      <v-btn
        v-if="alertOnly"
        icon
        variant="text"
        class="ma-0 pa-0"
        style="position: absolute; top: 8px; right: 8px; z-index: 10;"
        @click="cancel"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
  
      <v-card-title class="text-h6 text-center">
        {{ title }}
      </v-card-title>
      <v-card-text class="text-center">
        {{ message }}
      </v-card-text>
  
      <!-- Confirm dialog buttons -->
      <v-card-actions
        v-if="!alertOnly"
        class="justify-center"
      >
        <v-btn
          variant="text"
          @click="cancel"
        >
          <v-icon start>
            mdi-close
          </v-icon>Cancel
        </v-btn>
        <v-btn
          color="secondary"
          variant="flat"
          @click="confirm"
        >
          <v-icon start>
            mdi-check
          </v-icon>OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  title: String,
  message: String,
  alertOnly: Boolean
})

const emit = defineEmits(['update:modelValue', 'ok', 'cancel'])

const dialogVisible = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val)
})

const confirm = () => {
  emit('ok')
  dialogVisible.value = false
}

const cancel = () => {
  emit('cancel')
  dialogVisible.value = false
}
</script>
